import navigationAccountRec from "../navigation/navigationAccountRec";
import navigationFNS from "../navigation/navigationFNS";
import navigationGeneral from "../navigation/navigationGeneral";
import navigationIssues from "../navigation/navigationIssues";
import navigationSales from "../navigation/navigationSales";
import navigationTechStatistics from "../navigation/navigationTechStatistics";
import accountRecRoutes from "../router/accountRecRoutes";
import fnsRoutes from "../router/fnsRoutes";
import generalRoutes from "../router/generalRoutes";
import issuesRoute from "../router/isuessRoutes";
import salesRoute from "../router/salesRoutes";
import techStatisticsRoutes from "../router/techStatisticsRoutes";

const mainNavAndRoute = {
  GENERAL: { nav: navigationGeneral, route: generalRoutes },
  TECH_STAT: { nav: navigationTechStatistics, route: techStatisticsRoutes },
  SALES: { nav: navigationSales, route: salesRoute },
  ISSUES: { nav: navigationIssues, route: issuesRoute },
  FNS: { nav: navigationFNS, route: fnsRoutes },
  ACC_REC: { nav: navigationAccountRec, route: accountRecRoutes }
};

export default mainNavAndRoute;
